import React from 'react'
import { ImageAsset } from '../../Data/Images'

interface Props {
    image: ImageAsset
    ratio?: string
    label?: string
    className?: string
    rounded?: boolean
}

function ImageSlot({ image, ratio = '4 / 3', label, className = '', rounded = true }: Props) {
    return (
        <div className={`ibg-image ${rounded ? 'ibg-image--rounded' : ''} ${className}`} style={{ aspectRatio: ratio }}>
            {image.src
                ? <img src={image.src} alt={image.alt} loading="lazy" draggable={false} />
                : <div className="ibg-image__placeholder" role="img" aria-label={image.alt}>
                    {label && <span>{label}</span>}
                </div>}
        </div>
    )
}

export default ImageSlot
